import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';

// Remote device settings for point of sale devices
export default ProtoBaseModel.extend({
  catalogObjectToken: attr(String),
  selected: attr(Boolean),
  displayName: attr(String)
});